
<po-page-list #poPageListComponent
  p-title="Relatório de Lotes"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <div class="po-row">
    <po-button class="po-md-2 po-mb-2" p-kind="secondary" p-label="Excel" (p-click)="gerarExcel()" > </po-button>
  </div>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-input
      class="po-md-6"
      name="CZ02LOTE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ02LOTE"
      p-label="Lote"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CZ02PEDIDO"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ02PEDIDO"
      p-label="Pedido Origem"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CZ02PEDDES"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ02PEDDES"
      p-label="Pedido Destino"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CZ02UR"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ02UR"
      p-label="UR"
    ></po-input>
    <po-select
      class="po-md-6"
      name="CCOMSALDO"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CCOMSALDO"
      p-label="Apenas com Saldo"
      [p-options]="[
            { label: 'Não', value: 'N' },
            { label: 'Sim', value: 'S' }
        ]"
    ></po-select>
  </form>
</po-modal>
